import { ExtraService } from "model/insurance-product.interface";
import * as moment from "moment";

// Formatos en que el formulario de pasajeros entrega la fecha de nacimiento.
// No incluir 'YYYY-DD-MM': con día <= 12 moment lo acepta e invierte día y mes
// (ej: '2016-10-12' -> 10/12/2016).
const BIRTH_DATE_FORMATS = ['YYYY-MM-DD', 'DD-MM-YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD'];

/**
 * Normaliza una fecha de nacimiento a 'YYYY-MM-DD' (formato que espera el backend).
 * Devuelve null si no se puede interpretar.
 */
export function formatBirthDate(value: any): string | null {
  if (!value) return null;

  const date = value instanceof Date
    ? moment(value)
    : moment(String(value).split('T')[0], BIRTH_DATE_FORMATS, true);

  return date.isValid() ? date.format('YYYY-MM-DD') : null;
}

/**
 * Edades con las que se cotizó una asistencia, en el orden de la búsqueda.
 * paxList puede venir como array (payload de búsqueda) o como objeto (payloadUpdate).
 */
export function getInsurancePaxAges(payloadUpdate: any): number[] {
  const paxList = payloadUpdate?.products?.[0]?.insurances?.paxList;
  const paxAges = Array.isArray(paxList) ? paxList[0]?.paxAges : paxList?.paxAges;

  return Array.isArray(paxAges) ? paxAges.map((age: any) => Number(age)) : [];
}

/**
 * Edad del pasajero: la calculada en el formulario (fijada contra la edad cotizada)
 * o, si no viene, la calculada desde la fecha de nacimiento a hoy.
 */
export function getPaxAge(pax: any, birthDate: string | null): number | null {
  const age = Number(pax?.age);
  if (pax?.age !== null && pax?.age !== undefined && pax?.age !== '' && !isNaN(age)) {
    return age;
  }
  return birthDate ? moment().diff(birthDate, 'years') : null;
}

export function keyRandomUnique(): number {
    return Math.floor(Math.random() * 20000000000000) + Date.now();
}

export function getServiceExtra(addonsIncluded: any[], categoryId: any): ExtraService[] {

       let arr: any[] = [];

    if(addonsIncluded && addonsIncluded.length) {
      addonsIncluded.forEach((addon: any) => {

        switch(categoryId) {
          case 1:
                arr.push({name: addon.title, price: addon.netcost.amount});
          break;
        }

      });
    }

    return arr;
}

/**
 * Sanea lo que se tipea en un campo de porcentaje (Fee %):
 * - acepta coma o punto como separador decimal (se normaliza a punto),
 * - descarta cualquier otro carácter,
 * - no deja escribir más de dos decimales (no redondea: el tercer dígito no entra),
 * - limita al máximo indicado.
 * Devuelve el texto a mostrar en el input (puede terminar en '.' mientras se escribe).
 */
export function sanitizePercentageInput(value: any, max: number = 99.99): string {
  let clean = String(value ?? '').replace(/,/g, '.').replace(/[^0-9.]/g, '');

  const dotIndex = clean.indexOf('.');
  if (dotIndex !== -1) {
    const decimals = clean.slice(dotIndex + 1).replace(/\./g, '').slice(0, 2);
    clean = `${clean.slice(0, dotIndex) || '0'}.${decimals}`;
  }

  if (clean !== '' && Number(clean) > max) {
    clean = String(max);
  }

  return clean;
}

/**
 * Convierte el valor de un campo de porcentaje a número (acepta coma o punto).
 * Vacío o inválido -> 0.
 */
export function parsePercentage(value: any): number {
  const parsed = Number(String(value ?? '').replace(/,/g, '.'));
  return isNaN(parsed) ? 0 : parsed;
}

// Función helper para limpiar strings
export function cleanString(value: any): string | null {
  if (value === null || value === undefined) return null;
  const str = String(value);
  return str.trim() || null;
}

// Función para limpiar número (opcional)
export function cleanNumber(value: any): number | null {
  if (value === null || value === undefined) return null;
  const num = Number(value);
  return isNaN(num) ? null : num;
}

// Función para normalizar texto (quitar acentos, convertir a minúsculas)
export function normalizeText(text: string): string {
  if (!text) return '';

  return text
    .toLowerCase()
    .normalize('NFD') // Descompone caracteres acentuados
    .replace(/[\u0300-\u036f]/g, '') // Elimina diacríticos
    .trim();
}

